<script lang="ts">
	// for now only supports type "image/*"
	import { onMount } from 'svelte';
	import Text from '../Text.svelte';

	export let text = '';

	const isTouchDevice =
		typeof matchMedia === 'undefined' ? false : matchMedia('(hover: none)').matches;

	let container: HTMLDivElement;
	$: zoomableImage = container?.querySelector('.zoomable-image');

	let zoomed: boolean = false;

	function handleMouseMove(e: MouseEvent) {
		if (!zoomableImage) return;

		const { clientX, clientY } = e;
		const { left, top, width, height } = container.getBoundingClientRect();
		const x = (clientX - left) / width;
		const y = (clientY - top) / height;

		zoomableImage.style.transformOrigin = `${x * 100}% ${y * 100}%`;
		zoomableImage.style.transform = `scale(2)`;
	}

	function handleTouchMove(e: TouchEvent) {
		e.preventDefault();
		e.stopPropagation();

		if (!zoomableImage) return;

		const { clientX, clientY } = e.touches[0];
		const { left, top, width, height } = container.getBoundingClientRect();
		const x = (clientX - left) / width;
		const y = (clientY - top) / height;

		zoomableImage.style.transformOrigin = `${x * 100}% ${y * 100}%`;
		zoomableImage.style.transform = `scale(2)`;
	}

	$: handleZoomChange(zoomed);

	function handleZoomChange(...args: any[]) {
		if (!zoomableImage) return;

		if (zoomed) return;

		zoomableImage.style.transformOrigin = `50% 50%`;
		zoomableImage.style.transform = `scale(1)`;
	}

	function handleClick(e) {
		zoomed = !zoomed;

		handleMouseMove(e);
	}

	function disableZoom() {
		zoomed = false;
	}
</script>

<div
	class="zoomable-image-wrapper"
	bind:this={container}
	on:click={handleClick}
	on:mouseleave={disableZoom}
	on:mousemove={!isTouchDevice && zoomed ? handleMouseMove : undefined}
	on:touchmove={isTouchDevice && zoomed ? handleTouchMove : undefined}
	class:zoomed
>
	{#if isTouchDevice}
		<div class="notice">
			<Text
				key={zoomed ? 'zoomable_media_touch_notice_move' : 'zoomable_media_touch_notice_start'}
			/>
		</div>
	{/if}
	<div class="zoomable-image">
		<slot />
	</div>
</div>

<style lang="scss">
	.notice {
		background-color: color(primary);
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: v(content-padding-xs);
		border-radius: v(border-radius-lg);
		padding: v(content-padding-2xs) v(content-padding-xs);
		@include font(text-xs);
		opacity: 0.5;
		z-index: 1;
	}

	.zoomable-image-wrapper {
		position: relative;
		overflow: hidden;
		cursor: zoom-in;

		&.zoomed {
			cursor: zoom-out;
		}

		.zoomable-image {
			width: 100%;
			height: 100%;
			@include transition(transform);
		}

		:global(img) {
			max-width: 100%;
			max-height: 100%;
		}
	}
</style>
